import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProfileFeature, ProfileRole, Tenant } from 'src/app/models/auth/admin-tool.type';
import { TokenDetails } from 'src/app/models/auth/token-details.type';
import { ClientConfig } from 'src/app/models/core/client-config.type';

export const AuthActions = createActionGroup({
  source: 'auth',
  events: {
    RedirectToGateway: emptyProps(),
    logout: emptyProps(),
    Login: emptyProps(),
    LoginSuccess: props<{ tokenDetails: TokenDetails }>(),
    setActiveAccount: emptyProps(),
    setTokenDetails: props<{ tokenDetails: TokenDetails }>(),
    GetUserTenants: props<{ uniqueId: string }>(),
    GetUserTenantsSuccess: props<{ uniqueId: string; tenants: Array<Tenant> }>(),
    GetUserTenantsFailure: props<{ error: HttpErrorResponse }>(),
    GetUserRoles: props<{ uniqueId: string; tenant: string }>(),
    GetUserRolesSuccess: props<{ roles: Array<ProfileRole>; tenant: string }>(),
    GetUserRolesFailure: props<{ error: HttpErrorResponse }>(),
    GetUserFeatures: props<{ role: string; tenant: string }>(),
    GetUserFeaturesSuccess: props<{ features: Array<ProfileFeature> }>(),
    GetClientConfig: emptyProps(),
    GetClientConfigSuccess: props<{ config: ClientConfig }>(),
    GetClientConfigFailure: props<{ error: HttpErrorResponse }>(),
    GetUserFeaturesFailure: props<{ error: HttpErrorResponse }>(),
    setActiveRole: props<{ active_role: ProfileRole }>(),
    setActiveTenant: props<{ active_tenant: Tenant }>(),
  },
});
